export function toggleNoScroll(noScroll: boolean) {
  document.body.classList.toggle("noscroll", noScroll);
}

export function isElementInViewport(el: HTMLElement) {
  let rect = el.getBoundingClientRect();

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
